export default __webpack_public_path__ + "static/media/crate.d20295d1.jpg";